import { render, staticRenderFns } from "./FrmMore.vue?vue&type=template&id=0fda16c4&scoped=true"
import script from "./FrmMore.vue?vue&type=script&lang=js"
export * from "./FrmMore.vue?vue&type=script&lang=js"
import style0 from "./FrmMore.vue?vue&type=style&index=0&id=0fda16c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda16c4",
  null
  
)

export default component.exports